/*
検索条件オプション
*/
class SearchConditionOptions {
  private optionNameEls:NodeListOf<HTMLElement>;
  private optionListEls:NodeListOf<HTMLElement>;
  private optionInputEls:NodeListOf<HTMLInputElement>;

  private selectedCountId:number = 0;

  constructor() {
    this.optionNameEls = document.querySelectorAll('.search__condition-options-box-name');
    this.optionListEls = document.querySelectorAll('.search__condition-options-box-list-wrapper');
    this.optionInputEls = document.querySelectorAll('.search__condition-options-box-item-input');

    //nameクリックでlistを開閉
    this.optionNameEls.forEach(optionNameEl => {
      optionNameEl.addEventListener('click', this.onOptionNameClick.bind(this));
    });

    //listクリックイベント
    this.optionListEls.forEach(optionListEl => {
      optionListEl.addEventListener('click', this.onOptionListClick.bind(this));
    });

    //inputクリックイベント
    this.optionInputEls.forEach(optionInputEl => {
      optionInputEl.addEventListener('change', this.onOptionInputChange.bind(this));
    });

    document.body.addEventListener('click', this.onDocumentClick.bind(this));

    this.init();
  }

  init() {
    
    //optionにcheckedがある場合、selected-listに追加
    this.optionInputEls.forEach(optionInputEl => {

      const target = optionInputEl;

      if (target.checked) {
        this.addSelectedItem(target);
      }
    });

    
  }

  onOptionListClick(e:MouseEvent) {
    e.stopPropagation();
  }

  onOptionNameClick(e:MouseEvent) {
    e.stopPropagation();

    const target = e.currentTarget as HTMLElement;
    const parent = target.parentElement as HTMLElement;
    const list = parent.querySelector('.search__condition-options-box-list-wrapper') as HTMLElement;

    //自分のlist以外の開いているlistを閉じる
    this.optionListEls.forEach(optionListEl => {
      if (optionListEl.classList.contains('is-active') && optionListEl !== list) {
        optionListEl.classList.remove('is-active');
      }
    });
    
    list.classList.toggle('is-active');
  }

  //document.bodyクリックで、listが開いていたら閉じる
  onDocumentClick(e:MouseEvent) {
    this.optionListEls.forEach(optionListEl => {
      if (optionListEl.classList.contains('is-active')) {
        optionListEl.classList.remove('is-active');
      }
    });
  }

  onOptionInputChange(e:Event) {

    const target = e.currentTarget as HTMLInputElement;

    //inputがチェックされている場合.search__condition-options-selected-listに、inputのvalueと同名のitemを追加し、両方にidを振っておく
    if (target.checked) {
      this.addSelectedItem(target);

    } else {

      //inputがチェックされていない場合.search__condition-options-selected-listから、inputのvalueと同名のitemを削除し、inputのcheckedを外す
      const selectedList = document.querySelector('.search__condition-options-selected-list');
      const item = selectedList.querySelector(`[data-id="${target.dataset.id}"]`);
      if (item) {
        item.remove();
      } 
    }
  }

  addSelectedItem(target:HTMLInputElement) {
    //const value = decodeURIComponent(target.value).replace(/\+/g, ' ');
    const value = decodeURIComponent(target.dataset.tag).replace(/\+/g, ' ');
    const item = document.createElement('div');
    item.classList.add('search__condition-options-selected-item');
    item.innerHTML = `<span class="search__condition-options-selected-item-name">${value}</span>`;
    document.querySelector('.search__condition-options-selected-list')?.appendChild(item);
    target.dataset.id = `search__condition-options-selected-item-${this.selectedCountId}`;
    item.dataset.id = `search__condition-options-selected-item-${this.selectedCountId}`;

    //itemクリックで、itemを削除し、inputのcheckedを外す
    item.addEventListener('click', () => {
      item.remove();
      target.checked = false;
    });

    this.selectedCountId++;
  }

  reset() {
    //this.selectedCountId = 0;
    this.optionInputEls.forEach(optionInputEl => {
      optionInputEl.checked = false;
    });
    document.querySelector('.search__condition-options-selected-list').innerHTML = '';
  }
}

export default SearchConditionOptions;

